module.exports = __webpack_public_path__ + "images/sitting_robot.png";